import { useMemo } from "react";

import { type EnumValues, resolveEnumValueLabel } from "../../fields/utils";
import { CellSelect } from "../cell-fields/cell-select";

export function CellEnum<T extends object, V extends string | number>(props: {
  item: T;
  attr: keyof T;
  patch?: any;
  editing?: () => boolean;
  /** Either an enum or just an array of possible values. */
  values: EnumValues<V>;
  onChange?: (newValue: V) => void;
}) {
  const value = useMemo(() => props.item[props.attr], [props.item, props.attr]);

  return (
    <>
      {!props.patch ? (
        resolveEnumValueLabel(props.values, value as V) || "\u00A0"
      ) : (
        <CellSelect
          model={props.patch}
          attr={props.attr}
          values={props.values}
          onChange={props.onChange}
        />
      )}
    </>
  );
}
